import { render } from "./KanbanColumn.vue?vue&type=template&id=4e9a68a0&scoped=true"
import script from "./KanbanColumn.vue?vue&type=script&lang=js"
export * from "./KanbanColumn.vue?vue&type=script&lang=js"

import "./KanbanColumn.vue?vue&type=style&index=0&id=4e9a68a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9a68a0"]])

export default __exports__